import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import React from "react";

function UserProfile({ userName = "User", pageName }) {
  return (
    <>
      <div className="user-profile">
        {pageName ? (
          <strong>{pageName}</strong>
        ) : (
          <>
            <picture>
              <img src={Images?.user} alt="Logo" />
            </picture>
            <h3>{`${localization.hi} ${userName}`}</h3>
            <p>{localization.welcomeMessage}</p>
          </>
        )}
      </div>
    </>
  );
}

export default UserProfile;
